module.exports = __webpack_public_path__ + "media/images/building_ic-28aac2b46f75166ba4d1de6d42a10edf.svg";